
export const name = "developer-docs-ui-public-app";
export const version = "dev";
